import React from 'react';
import {Trans} from 'react-i18next';
import {Field} from 'formik';
import _get from 'lodash/get';
import CustomSwitch from '../../../../components/layout/CustomSwitch';
import RadioButton from '../../../../components/formik/RadioButton';
import CurrencyPriceTable from './CurrencyPriceTable';

export default function PriceSection({formikProps, type = 'product'}) {
  const filePrefix = type === 'treatment' ? 'treatment' : 'product';
  const isPriceFixed = formikProps.values.data.pricingType === 'fixed';

  return (
    <div className="kt-portlet skincare-product-layout-sub">
      <div className="skincare-product-layout-sub-title">
        <h5>
          <Trans i18nKey="p.s.addoreditskincareproduct.price">Price</Trans>
        </h5>
        <hr />
      </div>
      <div className="skincare-product-layout-sub-body">
        <div className="form-group row">
          <label className="col-4 col-form-label text-left">
            <Trans i18nKey="p.s.addoreditskincareproduct.enable.price">
              Enable Price
            </Trans>
          </label>
          <div className="col-8">
            <Field
              name="data.isPriceDisplayed"
              value={_get(formikProps, 'values.data.isPriceDisplayed', false)}
              component={CustomSwitch}
            />
          </div>
        </div>
        {_get(formikProps, 'values.data.isPriceDisplayed', false) && (
          <>
            <div className="form-group row">
              <label className="col-4 col-form-label text-left">
                <Trans i18nKey="p.s.addoreditskincareproduct.pricing.type">
                  Pricing Type
                </Trans>
              </label>
              <div className="col-8">
                <Field
                  name="data.pricingType"
                  label={
                    <Trans i18nKey="p.s.addoreditskincareproduct.pricing.type.fixed.price">
                      Fixed Price
                    </Trans>
                  }
                  value="fixed"
                  component={RadioButton}
                  style={{
                    marginRight: '20px',
                    marginTop: '10px',
                  }}
                />
                <Field
                  name="data.pricingType"
                  label={
                    <Trans i18nKey="p.s.addoreditskincareproduct.pricing.type.variable.price">
                      Variable Price
                    </Trans>
                  }
                  value="variable"
                  component={RadioButton}
                  style={{
                    marginRight: '20px',
                    marginTop: '10px',
                  }}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-4 col-form-label text-left">
                <Trans i18nKey="p.s.addoreditskincareproduct.price">
                  Price
                </Trans>
              </label>
              <div className="col-8">
                <CurrencyPriceTable
                  formikProps={formikProps}
                  fieldName="data.prices"
                  priceType={formikProps.values.data.pricingType || 'fixed'}
                />
              </div>
            </div>
            <div className="form-group row">
              <label className="col-4 col-form-label text-left">
                <Trans i18nKey="p.s.addoreditskincareproduct.pricing.example">
                  Example
                </Trans>
              </label>
              <div className="col-8">
                <img
                  alt="price"
                  src={
                    isPriceFixed
                      ? require(`../../../../assets/images/skincare/products/${filePrefix}_fix_org.png`)
                      : require(`../../../../assets/images/skincare/products/${filePrefix}_var_low.png`)
                  }
                  style={{
                    maxWidth: filePrefix === 'product' ? '250px' : '300px',
                    border: '1px solid #ddd',
                    borderRadius: '10px',
                  }}
                />
                <img
                  alt="price"
                  src={
                    isPriceFixed
                      ? require(`../../../../assets/images/skincare/products/${filePrefix}_fix_sel.png`)
                      : require(`../../../../assets/images/skincare/products/${filePrefix}_var_hig.png`)
                  }
                  style={{
                    maxWidth: filePrefix === 'product' ? '250px' : '300px',
                    marginLeft: '20px',
                    border: '1px solid #ddd',
                    borderRadius: '10px',
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
